mutation DeleteInternalExpenses($ids: [ID!]!) {
  deleteInternalExpenses(ids: $ids) {
    id
    deletedAt
  }
}
